export default "https://cdn.retino.com/dist/files/react/components/RatingEmoji/img/emoji_positive.svg";